module.exports = __webpack_public_path__ + "static/media/sup_icons_info.d1115d15.svg";